var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import AddBoothModal from './components/AddBoothModal.vue';
import MixinProfessional from '@/common/mixins/professional';
import { getEnv } from '@/common/utils/env';
import CompanyChangePopover from './components/CompanyChangePopover.vue';
import { getStorage, getCookie } from '@lhb/cache';
var orgUrl = require('config/env').orgUrl;
var WorkbenchNav = /** @class */ (function (_super) {
    __extends(WorkbenchNav, _super);
    function WorkbenchNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delayCollapse = false; // 延迟收起
        _this.searchKey = '';
        _this.timeout = null;
        _this.historyStores = [];
        _this.searchStores = [];
        _this.page = 1;
        _this.finished = false;
        return _this;
    }
    Object.defineProperty(WorkbenchNav.prototype, "permissions", {
        /* computed */
        get: function () {
            return this.$store.state.common.permission || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "user", {
        get: function () {
            return this.$store.state.common.user || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "ENV", {
        get: function () {
            var isProd = process.env.NODE_ENV === 'production';
            var env = isProd ? getEnv() : process.env.npm_config_env;
            return env;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "activeMenu", {
        get: function () {
            var route = this.$route;
            var meta = route.meta, path = route.path;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "hasShop", {
        get: function () {
            var STORE = this.$store.state.common.storeInfo;
            return Array.isArray(STORE) && STORE.length;
        },
        enumerable: false,
        configurable: true
    });
    /* hooks */
    WorkbenchNav.prototype.mounted = function () {
    };
    /* methods */
    // 工作台路由跳转
    WorkbenchNav.prototype.jump = function (path) {
        this.$router.push({ path: path });
    };
    WorkbenchNav.prototype.jumpToCompanyManage = function () {
        var token = getCookie('newPmsToken') || getStorage('newPmsToken');
        var url = orgUrl;
        if (this.ENV === 'IE') {
            url = 'https://ie-orm.lanhanba.net/';
        }
        window.open(url + "?token=" + token + "&clientKey=1000010");
    };
    WorkbenchNav.prototype.checkActive = function (item) {
        var navs = this.$route.path.split('/');
        if (item.indexOf('/') > -1) {
            var itemArr = item.split('/');
            return itemArr.every(function (e, i) { return e === navs[i + 1]; });
        }
        return navs[1].indexOf(item) > -1;
    };
    // 新建展位
    WorkbenchNav.prototype.addBoothHandle = function () {
        this.$refs.addBoothModal && this.$refs.addBoothModal.init();
    };
    WorkbenchNav = __decorate([
        Component({
            components: { AddBoothModal: AddBoothModal, CompanyChangePopover: CompanyChangePopover },
            mixins: [MixinProfessional],
        })
    ], WorkbenchNav);
    return WorkbenchNav;
}(Vue));
export default WorkbenchNav;
